<template>
    <time v-if="presentation.kind === 'valid'" v-bind="$attrs" :datetime="presentation.datetime"
        >{{ presentation.text }}<span v-if="presentation.absoluteText" class="sr-only">{{ `, ${presentation.absoluteText}` }}</span></time
    >
    <span v-else-if="presentation.kind === 'invalid'" v-bind="$attrs">{{ presentation.text }}</span>
</template>

<script lang="ts">
import type { DateFormat, DateInput } from "~vue/utils/formatDate";
import type { DateTime } from "luxon";

interface BaseDateProps {
    value: DateInput;
    format?: DateFormat;
    // What format="relative" measures from. DateTime.now() is not reactive, so a label that has to
    // keep moving ("just now" -> "2 minutes ago") passes a ticking ref such as useNow().
    now?: Date | DateTime;
}
</script>

<script setup lang="ts">
import { currentDateFormatContext, presentDate } from "~vue/utils/formatDate";
import { DateTime as LuxonDateTime } from "luxon";
import { computed } from "vue";

// Two root branches, so attrs are bound by hand on each instead of falling through.
defineOptions({ inheritAttrs: false });

const { value, format = "date", now } = defineProps<BaseDateProps>();

const presentation = computed(() => {
    const context = currentDateFormatContext();
    if (now !== undefined) {
        context.now = LuxonDateTime.isDateTime(now) ? now : LuxonDateTime.fromJSDate(now);
    }
    return presentDate(value, format, context);
});
</script>
